import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { fetchAll } from '../service/players';
import { loading } from '@actions';

export const loadPlayers = () => async (dispatch, getState) => {
  let players = get(getState(), 'players.list');
  if (!isEmpty(players)) {
    return players;
  }

  dispatch(loading(true));
  let res = await fetchAll();
  dispatch({ type: 'PLAYERS_SET', payload: res.data });
  dispatch(loading(false));
  return res;
};
